
import { Accordion, AccordionDetails, AccordionSummary, Divider, Typography,Grid } from "@mui/material";
import {   useState } from "react"; // Added useCallback
import { CheckGreen, DownIcon, InfoIcon } from "../../../../../assets/common-svg/CommonSvg";
import {  useSelector } from "react-redux";
import { selectCurrentCycle } from "../../../../../bmr/slices/common";
import CryoLsmFormDialog from "./CryoLsmFormDialog";
import { selectDynamicBags } from "../../../../../bmr/slices/manufacturer"; 
import ReprintComponent from "../../../../../bmr/pages/Manufacturer/RePrintComponent"

const CryopeserveView = ({patientData,patientInfo,patientMedicalInfo,bagCount, formProps, getTimeLine}) => {
    const currentCycle = useSelector(selectCurrentCycle)
    const bagDynamic = useSelector(selectDynamicBags)
    const [reprintData, setReprintData] = useState(null); // Separate state for reprint
    const [reprintModalOpen, setReprintModalOpen] = useState(false);
    const [carTFormExpanded, setCarTFormExpanded] = useState(true)

    const bloodInfo = [{
     label:'Total CD3+ Count',
     value: `${currentCycle?.total_blood || 0} ${' x10⁶ Cells'}`
    },
   {
     label:'Used CD3+ Count',
     value: `${currentCycle?.used_blood || 0} ${' x10⁶ Cells'}`
   },
   {
     label:'Remaining CD3+ Count',
     value: `${currentCycle?.remaining_blood || 0} ${' x10⁶ Cells'}`,
   }]

    const handleReprint = async (index) => {
    
    const freshReprintData = {
      printPatientInfo: {...patientData,batch_no: currentCycle?.batch_no},
      patientMedicalInfo,
      patientInfo, 
      bagCount:bagDynamic?.length,
      bagData :bagDynamic[index],
      bagIndex:index,
      apheresisDate: currentCycle?.data?.find((it)=>it?.slug =='apheresis')?.completed_date,
      cryo:true
    };
    setReprintData(freshReprintData);
    setReprintModalOpen(true);
  };

    return <div>
        <Accordion
            className={` w-100  !rounded-lg ${carTFormExpanded ? " pt-3" : " "}`}
            sx={{
                borderLeft: `4px solid ${bagDynamic?.length < 1
                    ? "#FB9D2C"
                    : "#00B278"
                    }`,
            }}
            expanded={carTFormExpanded} // <-- make it controlled
            onChange={() => setCarTFormExpanded((prev) => !prev)} // <-- toggle manually
        >
            <AccordionSummary
                expandIcon={
                    <div className="d-flex gap-3 align-items-center">
                        <DownIcon />
                    </div>
                }
                aria-controls="panel1-content"
                id="panel1-header"
            >
                    <Typography className="flex flex-col gap-2 ">
                        <span className="font-bold text-[0.9rem]">Cryopreserve Of LSM</span>
                        <p className="flex gap-2">
                            {bagDynamic?.length < 1 ? (
                                <span className="flex gap-3" style={{ color: "#FB9D2C" }}>
                                    <InfoIcon Height={20} Width={20} Filled="#FB9D2C" />
                                    {"In-Progress"}
                                </span>
                            ) : (
                                <span className="flex gap-3" style={{ color: "#00B278" }}>
                                    <CheckGreen Filled="#00B278" />
                                    {"Completed"}
                                </span>
                            )}{" "}
                            
                        </p>
                    </Typography>
                
            </AccordionSummary>
            <AccordionDetails>
                <Divider />
        {<>
                <Grid className="mb-3 mt-3 relative flex gap-3">
                                            {bloodInfo?.map((blood,index) => (
                                                <p key={'_key_'+index} className="bg-[#E8EFFC] text-[#1958EB] font-normal px-3 py-2 rounded-md w-full">
                                                {blood?.label}: <span className="font-bold">{blood?.value}</span>
                                                </p>
                                            ))}
                                            </Grid>
                                    <hr /></>}
              
              <CryoLsmFormDialog  showLsm={false} id={patientData?.id} formProps={formProps} getTimeLine={getTimeLine} onReprint={handleReprint}/>

          <ReprintComponent
                 open={reprintModalOpen}
                 onClose={() => {
                   setReprintModalOpen(false);
                 }}
                 printData={reprintData}
                 patientInfo={patientInfo}
                 bagCount={bagCount}
               />

            </AccordionDetails>
        </Accordion>
    </div >
}
export default CryopeserveView;